export const calculatePosition = (nodeType: string, num: number, posX: number, posY: number, inDepartmentLength: number, outDepartmentLength: number) => {
    let bgColor = '#fff';
    let borderColor = '#fff';
    let newPosition: { x: number; y: number } = { x: 0, y: 0 };

    const centerInY = Math.abs(inDepartmentLength - 1) / 2;

    if (nodeType === 'default') {
        newPosition = { x: 0, y: centerInY * posY + 24 };
        bgColor = '#EDFFD3';
        borderColor = '#77b800';
    } else {
        if (nodeType === 'In') {
            newPosition = { x: -posX, y: num * 1.2 * posY - 40 };
        } else if (nodeType === 'Out') {
            newPosition = { x: posX * 1, y: posY * (num * 1.2 - Math.abs(outDepartmentLength - 1) / 2 + centerInY) - 40 };
        }
        bgColor = '#fff';
        borderColor = '#a0a2a3';
    }

    return { newPosition, bgColor, borderColor };
};
